import { useState, useRef, useEffect } from 'react';
import { Stack, IconButton, Typography, CircularProgress } from '@mui/material';
import { MicNone, Stop } from '@mui/icons-material';
import { wsurl } from '../Common';

/** Registratore nota vocale: al Stop invia subito la nota al cartellone `elem`. */
export default function RecorderInline({ elem, notify }) {
  const [recording, setRecording] = useState(false);
  const [sending, setSending] = useState(false);
  const [secs, setSecs] = useState(0);
  const recRef = useRef(null);
  const streamRef = useRef(null);

  // rilascia il microfono se il componente viene smontato durante la registrazione (es. cambio tab)
  useEffect(() => () => { streamRef.current?.getTracks().forEach(t => t.stop()); }, []);

  useEffect(() => {
    if (!recording) return;
    const t = setInterval(() => setSecs(s => s + 1), 1000);
    return () => clearInterval(t);
  }, [recording]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      const rec = new MediaRecorder(stream);
      const chunks = [];
      rec.ondataavailable = (e) => chunks.push(e.data);
      rec.onstop = () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(chunks, { type: 'audio/mp3' });
        if (elem == null) return;
        const fd = new FormData();
        fd.append('cid', elem);
        fd.append('file', new File([blob], 'recording.mp3', { type: 'audio/mp3' }));
        setSending(true);
        fetch(wsurl + '/audionote', { method: 'POST', body: fd })
          .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); notify(`Nota vocale salvata sul ${elem} ✓`, 'success'); })
          .catch(() => notify('Errore invio nota vocale', 'error'))
          .finally(() => setSending(false));
      };
      rec.start();
      recRef.current = rec;
      setSecs(0);
      setRecording(true);
    } catch {
      notify('Microfono non disponibile', 'error');
    }
  };

  const stop = () => {
    recRef.current?.stop();
    setRecording(false);
  };

  const mmss = `${String(Math.floor(secs / 60)).padStart(2, '0')}:${String(secs % 60).padStart(2, '0')}`;

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ border: '1px solid #e2e8f0', borderRadius: 2, px: 1.5, py: 0.5 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>
        Nota vocale {recording && <span style={{ color: '#dc2626' }}>● {mmss}</span>}
      </Typography>
      {sending && <CircularProgress size={18} />}
      {!recording
        ? <IconButton color="primary" disabled={elem == null || sending} onClick={start}><MicNone /></IconButton>
        : <IconButton sx={{ bgcolor: '#dc2626', color: 'white', '&:hover': { bgcolor: '#b91c1c' } }} onClick={stop}><Stop /></IconButton>}
    </Stack>
  );
}
